export function encodePlannerShare({ selectedIds, guestCount, occasion }) {
  const json = JSON.stringify({ s: selectedIds, g: guestCount, o: occasion });
  return btoa(unescape(encodeURIComponent(json)));
}

export function decodePlannerShare(encoded) {
  if (!encoded || typeof encoded !== 'string') return null;
  try {
    const binary = atob(encoded.trim());
    const json = decodeURIComponent(escape(binary));
    return JSON.parse(json);
  } catch {
    return null;
  }
}
